// Thumbnails slider
var secondarySlider = new Splide('#secondary-slider', {
  rewind: false,
  arrows: false,
  isNavigation: true,
  gap: 10,
  pagination: false,
  cover: true,
  drag: true,
}).mount();


// Get slide duration from Shopify Customizer
var primarySliderElement = document.querySelector('#primary-slider');

var slideDuration = Number(
  primarySliderElement.dataset.slideDuration
);


// Main slider
var primarySlider = new Splide('#primary-slider', {
  type: 'loop',
  start: 0,
  perPage: 1,
  arrows: false,
  autoplay: true,
  cover: true,
  heightRatio: 0.5,

  // Duration controlled from Shopify Customizer
  interval: slideDuration,

  // Transition animation speed
  speed: 1200,

  easing: 'ease-in-out',

  pagination: false,
  padding: 0,

  pauseOnHover: false,
  pauseOnFocus: false,
  pauseOnInteraction: false,

  breakpoints: {
    1435: {
     
      heightRatio: 0.7,
    },

    1220: {
      heightRatio: 0.7,
    },

    992: {
      heightRatio: 0.8,
    },

    920: {
      heightRatio: 0.9,
    },

    749: {
      heightRatio: false,
    },
  },
});


// Show slider after Splide is fully initialized
primarySlider.on('mounted', function () {
  document
    .querySelector('#primary-slider')
    .classList.add('is-initialized');
});


// Sync primary and thumbnail sliders
primarySlider.sync(secondarySlider).mount();


// Header and slideshow scroll effects
document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".header");
  const sticky_header_background =
    document.querySelector(".header-wrapper");

  const slideshow =
    document.querySelector(".slideshow-section-target");

  const announcement =
    document.querySelector(".announcement-bar-section");

  // Stop if required elements do not exist
  if (!header || !slideshow || !announcement) return;


  const headerHeight = header.offsetHeight;
  const slideshowTop = slideshow.offsetTop;
  const slideshowHeight = slideshow.offsetHeight;

  const parallaxSpeed = 0.3;

  let ticking = false;


  function update() {

    const scrollY = window.scrollY;


    // PARALLAX EFFECT
    if (
      scrollY + window.innerHeight > slideshowTop &&
      scrollY < slideshowTop + slideshowHeight
    ) {

      const relativeScroll = scrollY - slideshowTop;

      const yPos =
        relativeScroll * parallaxSpeed;


      slideshow.style.transform =
        `translate3d(0, ${yPos}px, 0)`;

      slideshow.style.zIndex = "1";
    }


    // ANNOUNCEMENT STICKY LOGIC
    const slideshowStickyEnd =
      slideshowTop +
      slideshowHeight -
      headerHeight;


    if (scrollY >= slideshowStickyEnd) {

      announcement.style.position = "fixed";

      announcement.style.top =
        headerHeight + "px";

      announcement.style.zIndex = "10";

      announcement.classList.add("is-sticky");

    } else {

      announcement.style.position = "";

      announcement.style.top = "";

      announcement.style.zIndex = "";

      announcement.classList.remove("is-sticky");
    }


    // HEADER BACKGROUND
    if (
      announcement.classList.contains('is-sticky')
    ) {

      sticky_header_background.classList.add(
        'background_color'
      );

    } else {

      sticky_header_background.classList.remove(
        'background_color'
      );
    }


    ticking = false;
  }


  // Scroll event
  window.addEventListener("scroll", function () {

    if (!ticking) {

      window.requestAnimationFrame(update);

      ticking = true;
    }
  });

});